import React from "react";
import { Button } from "./styles";

export default function CustomButton ({children, backgroundColor, margin, onClick}) {

    return(
        <Button backgroundColor={backgroundColor} margin={margin} onClick={onClick}>{children}</Button>
    )
}